export default "__VITE_ASSET__BUkqXWNh__"